import { useTranslation } from "react-i18next";

import type { GroupDetails, GroupParticipant } from "../../services/group";
import GroupMemberRow from "./GroupMemberRow";
import GroupSubPageHeader from "./GroupSubPageHeader";
import { GroupUserRowSkeleton } from "./GroupUserListSkeleton";

type GroupManagersPageProps = {
  groupDetails?: GroupDetails;
  isLoading?: boolean;
  onBack: () => void;
};

export default function GroupManagersPage({
  groupDetails,
  isLoading,
  onBack,
}: GroupManagersPageProps) {
  const { t } = useTranslation("messenger.user");

  const owner = groupDetails?.owner
    ? ({ ...groupDetails.owner, is_owner: true } as GroupParticipant)
    : null;

  return (
    <div className="flex h-full flex-col bg-white">
      <GroupSubPageHeader
        title={t("Managers")}
        onBack={onBack}
        onConfirm={onBack}
      />

      <div className="min-h-0 flex-1 overflow-y-auto">
        {isLoading ? (
          <GroupUserRowSkeleton />
        ) : owner ? (
          <GroupMemberRow participant={owner} />
        ) : null}
      </div>
    </div>
  );
}
